import React, {
	useState, useCallback, useEffect, useRef
}from 'react'
import {
	Select, Button, Modal, Table, Input, Space, Tabs
}from 'antd'
import i18n from '../../../localization'
import {
	useDispatch, useSelector
}from 'react-redux'
import {
	reMessageTemplateTypeActions
}from '../../nsi/ReMessageTemplateTypes/actions'
import {
	messageTemplateActions
}from '../store/actions'
import CustomButton from '../../../components/ButtonCustom'
import 'antd/lib/popover/style/index.css'
import 'antd/lib/collapse/style/index.css'
import './style.css'
import {
	CustomSelect
}from '../../../components/CustomSelect'

const { TabPane } = Tabs

const {
	Option
} = Select
const {
	Search
} = Input

const TableTemplates = ({
	searchList, isRu, isLoading, getRow, onChange, list, clickStyleRow
}) => {
	const onSearch = (value, type) => searchList(value)

	//Add filters under collapse for Rus and Eng

	const columns = [
		{
			title     : i18n.name[isRu],
			key       : 'name',
			dataIndex : 'name',
			width     : 200,
			render    : (text, record) => text
		},
		{
			title     : i18n.textRus[isRu],
			key       : 'textRus',
			ellipsis  : true,
			dataIndex : 'textRus',
			render    : (text, record) => text
		},
		{
			title     : i18n.textBel[isRu],
			key       : 'textBel',
			dataIndex : 'textBel',
			ellipsis  : true,
			render    : (text, record) => text
		}

		/* {
		   	title  : isRu ? 'Выбрать язык' : 'Выбраць мову',
		   	key    : 'action',
		   	render : (text, record) => (
		   		<div className="language_buttons">
		   			<Button onClick={ () => getText(record.textRus) }>
		           Рус
		   			</Button>
		   			<Button onClick={ () => getText(record.textBel) }>
		           Бел
		   			</Button>
		   		</div>
		   	)
		   } */
	]
	return (
		<>
			<Table
				className="table_modal_template_messages"
				columns={ columns }
				dataSource={ list.items }
				expandable={
					{
						columnWidth       : 0,
						expandRowByClick  : true,
						expandIcon        : (render) => null,
						expandedRowKeys   : clickStyleRow? [clickStyleRow.key] : [],
						expandedRowRender : record => (
							<div className="expanded-full-text">
								<span>
									{ record.textRus }
								</span>
								<span>
									{ record.textBel }
								</span>
							</div>
						)

					}
					// eslint-disable-next-line react/jsx-indent
				}
				loading={ isLoading }
				locale={ {
					filterReset : isRu ? 'Отмена' : 'Адмена',
					emptyText   : i18n.empty[isRu]
				} }
				pagination={ {
					current  : list.page ?? 1,
					pageSize : list.pageSize ?? 5,
					total    : list.count
				} }
				rowClassName={ (record) => (record.id === clickStyleRow?.id ? 'clickRowStyle' : '') }
				onChange={ (filters) => {
					onChange(filters)
				} }
				onRow={ (record, rowIndex) => {
					return {
						onClick: event => {
							getRow(record)
						}
					}
				} }
			/>

		</>
	)
}

const ModalTemplateMessages = ({
	isRu, visibleTemplate, setVisibleTemplate, getText
}) => {
	const [valueSelect, setValueSelect] = useState(null)
	const [currentPanel, setCurrentPanel] = useState('1')
	const [clickStyleRow, setClickStyleRow] = useState(null)

	const {
		user
	} = useSelector((state) => state.userReducer)
	const {
		currentItems, isSending
	} = useSelector(state => state.reMessageTemplateTypeReducer)
	const list = useSelector(state => {
		if (state.messageTemplateReducer.list.items){
			const items = state.messageTemplateReducer.list.items
			const newItems = items.reduce((accum, next, index) => {
				return [
					...accum,
					{
						...next,
						key: index
					}

				]
			}, [])
			return {
				...state.messageTemplateReducer.list,
				items: newItems
			}
		}
		return []
	})

	const isLoading = useSelector(state => state.messageTemplateReducer.isLoading)

	const dispatch = useDispatch()

	const getTypes = useCallback(() => {
		dispatch(reMessageTemplateTypeActions.GetMessageTemplatesTypesPaged({
			page     : 1,
			pageSize : 1000
		}))
	}, [dispatch])

	const getList = useCallback((params) => {
		dispatch(messageTemplateActions.getList(params))
	}, [dispatch])

	useEffect(() => {
		getTypes()
	}, [getTypes])

	const handleOk = e => {
		setVisibleTemplate(false)
	}

	const handleCancel = e => {
		setVisibleTemplate(false)
	}

	const handleChange = value => {
		setValueSelect(value)
		getList({
			id       : value,
			page     : 1,
			pageSize : 10,
			reOrgId  : currentPanel === '1' ? null : user.reOrg?.id
		})
	}

	const onChange = (filters, reOrgId) => {
		getList({
			id       : valueSelect,
			page     : filters.current,
			pageSize : filters.pageSize,
			reOrgId
		})
	}

	function callback(key){
		setCurrentPanel(key)
		getList({
			id       : valueSelect,
			page     : 1,
			pageSize : 10,
			reOrgId  : key === '1' ? null : user.reOrg?.id
		})
		setClickStyleRow(null)
	}

	const searchList = (text) => {
		getList({
			id       : valueSelect,
			page     : 1,
			pageSize : 10,
			filter   : text,
			reOrgId  : currentPanel === '1' ? null : user.reOrg?.id
		})
		setClickStyleRow(null)
	}

	const getRow = (record) => {
		setClickStyleRow((prev) => (prev ? prev.key == record.key ? null : record : record))
	}

	return (
		<Modal
			destroyOnClose
			footer={ null }
			title="Шаблон"
			visible={ visibleTemplate }
			width={ 840 }
			onCancel={ handleCancel }
			onOk={ handleOk }
		>
			<Search
				disabled={ !valueSelect }
				placeholder={ isRu ? 'Поиск по тексту шаблона':'Пошук па тэксту шаблона' }
				style={ {
					width        : 530,
					marginBottom : '24px'
				} }
				onSearch={ (value) => searchList(value) }
			/>
			<CustomSelect
				disabled={ isSending }
				loading={ isSending }
				notFoundContent={ null }
				placeholder={ i18n.messageTemplates[isRu] }
				style={ {
					width        : '530px',
					marginBottom : '16px'
				} }
				value={ valueSelect }
				onChange={ handleChange }
			>
				{
					currentItems.items ?
						currentItems.items.map((item, index) => {
							return (
								<Option
									key={ index }
									value={ item.id }
								>
									{ isRu ? item.name : item.nameBel ? item.nameBel : item.name }
								</Option>
							)
						})
						: null
				}
			</CustomSelect>

			<Tabs
				defaultActiveKey="1"
				id="template-tabs"
				onChange={ callback }
			>
				<TabPane
					key="1"
					tab={ isRu ? 'Системные шаблоны' : 'Сістэмныя шаблоны' }
				>
					<TableTemplates
						clickStyleRow={ clickStyleRow }
						getRow={ getRow }
						isLoadin={ isLoading }
						isRu={ isRu }
						list={ list }
						searchList={ searchList }
						onChange={ (filters) => onChange(filters) }
					/>
				</TabPane>
				<TabPane
					key="2"
					tab={ isRu ? 'Локальные шаблоны' : 'Лакальныя шаблоны' }
				>
					<TableTemplates
						clickStyleRow={ clickStyleRow }
						getRow={ getRow }
						isLoading={ isLoading }
						isRu={ isRu }
						list={ list }
						searchList={ searchList }
						onChange={ (filters) => {
							onChange(filters, user.reOrg?.id)
							setClickStyleRow(null)
						} }
					/>
				</TabPane>

			</Tabs>
			<div className="template-result-buttons">
				<CustomButton
					disabled={ !clickStyleRow }
					type="turquoise"
					onClick={ () => getText(clickStyleRow.textBel) }
				>
					Уставіць шаблон на беларускай мове
				</CustomButton>
				<CustomButton
					disabled={ !clickStyleRow }
					type="orange"
					onClick={ () => getText(clickStyleRow.textRus) }
				>
Вставить шаблон на русском языке
				</CustomButton>
			</div>
		</Modal>
	)
}

export default ModalTemplateMessages